import React, { PureComponent } from 'react';
import Input from './Input';
import { Async } from 'react-select';
import s from './IndustryCustomInput.scss';
import { debounce } from 'lodash';
import cx from 'classnames';

class IndustryCustomInput extends PureComponent {
  fetchIndustries = debounce(async (term, callback) => {
    const fetchedIndustries = await this.getAutocomplete(term);
    callback(null, { options: fetchedIndustries });
  }, 200);

  loadOptions = (term, callback) => {
    this.fetchIndustries(term, callback);
  };

  getAutocomplete = async term => {
    const { industriesFetcher } = this.props;
    return industriesFetcher(term);
  };

  render() {
    const { placeHolderText = '', onIndustryTextChanged, onIndustrySelected, industryText, ...rest } = this.props;

    return (
      <Async
        inputRenderer={inputProps => {
          return (
            <div style={{ display: 'inline-block', width: '100%' }}>
              <Input
                dataAid="industry-input"
                g
                id="industryInput"
                placeholder={placeHolderText}
                onChange={e => {
                  onIndustryTextChanged(e.target.value);
                }}
                onFocus={this.scrollToInput}
                inputProps={inputProps}
                text={industryText}
                limit={40}
                {...rest}
              />
            </div>
          );
        }}
        loadOptions={this.loadOptions}
        arrowRenderer={null}
        className="selectWrapper"
        placeholder=""
        onChange={onIndustrySelected}
        loadingPlaceholder={false}
        valueKey="id"
        searchPromptText=""
        clearable={false}
        openOnClick={false}
        onBlurResetsInput={false}
        filterOptions={false}
        backspaceRemoves={false}
        onCloseResetsInput={false}
        valueRenderer={() => {}}
        noResultsText=""
        labelKey="label"
        menuContainerStyle={{
          border: 'none',
          boxShadow: '0 1px 3px 0 rgba(31, 79, 113, 0.15)',
          width: '248px',
          borderRadius: '8px'
        }}
        isLoading={false}
        menuStyle={{ padding: '16px 24px 16px 12px' }}
        optionClassName={cx(s.option)}
      />
    );
  }
}

export default IndustryCustomInput;
